import React from 'react'

interface PreformattedTextProps {
  text: string
}

export function PreformattedText({text, }: PreformattedTextProps) {
  let lines = text.split("\n");
  return <React.Fragment>{lines.map(function(line, i) {
    return (
      <React.Fragment key={i}>{line}<br/></React.Fragment>
    );
  })}</React.Fragment>;
}
